import { useEffect, useState } from 'react';
import { ApolloProvider, type ApolloClient, type NormalizedCacheObject } from '@apollo/client';
import { useErrorHandler } from 'react-error-boundary';
import { initGraphql } from './init';
import Router from 'routes/Router';
import LoadingPage from 'pages/LoadingPage';

export const ApolloLoader = (): JSX.Element => {
  const [apolloClient, setApolloClient] = useState<ApolloClient<NormalizedCacheObject> | undefined>();
  const handleError = useErrorHandler();

  useEffect(() => {
    if (apolloClient === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      initGraphql(handleError)
      .then((client) => setApolloClient(client))
      // .catch((error) => handleError(error));
    }
  });

  if (apolloClient !== undefined) {
    return (
      <ApolloProvider client={apolloClient}>
        <Router />
      </ApolloProvider>
    );
  } else {
    return <LoadingPage />;
  }
};
